// extracted by mini-css-extract-plugin
export default {"textShieldRoot":"textShieldRoot___R0kHZ","s":"s___KHv0c","m":"m___NUoLa","l":"l___SkKnp","static":"static___PRCkD","textShieldImg":"textShieldImg___NeeFT"};